import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useRef } from 'react';
import moment from 'moment-timezone';
import { useEditableField } from '../../../hooks/use-editable-field';
import { CampaignName } from './campaign-name';
import { getTimezone, useSession } from '../../../../../../infra/session';
import { useRouteQuery } from '../../../../../../infra/routing';
export var CampaignNameContainer = function () {
    var inputRef = useRef(null);
    var session = useSession().data;
    var timezone = getTimezone(session);
    var _a = useEditableField('displayName'), displayName = _a.field, setCampaignDisplayName = _a.setValue;
    var dateFormat = useEditableField('dateFormat').field;
    var isDuplicateCampaign = useRouteQuery().isDuplicateCampaign;
    var defaultCampaignName = useMemo(function () {
        return "New Campaign - ".concat(moment(new Date()).tz(timezone).format("".concat(dateFormat.value, " HH:mm:ss")));
    }, []);
    var initialCampaignDisplayNameValue = useMemo(function () {
        return displayName.value || defaultCampaignName;
    }, [defaultCampaignName]);
    useEffect(function () {
        if (!displayName.value) {
            setCampaignDisplayName(initialCampaignDisplayNameValue);
        }
    }, [initialCampaignDisplayNameValue]);
    var handleCampaignNameChange = function (newValue) {
        setCampaignDisplayName(newValue);
    };
    var handleOnBlur = function (newValue) {
        if (newValue === '') {
            setCampaignDisplayName(defaultCampaignName);
        }
    };
    return (_jsx(CampaignName, { onChange: handleCampaignNameChange, value: displayName.value, inputRef: inputRef, onBlur: handleOnBlur, autoFocus: !!isDuplicateCampaign }));
};
